import Highcharts from "highcharts/highcharts";
import { groupBy as _groupBy } from 'lodash';

class EnquiriesExpenditureController {
  constructor($scope) {
    "ngInject";

    //Begin Services
    this.$scope = $scope;
    //End Services

    //Begin Data
    this.hasNoTarget = false;
    this.chartContainerId = `chartContainer${this.getGuid()}`
    this.chart = null;
    //End Data
    
    //Begin Initialize
    this.$onChanges = (changesObj) => {
      if (changesObj.data && changesObj.data.currentValue) {
        this.chart = this.generateChart();
      }
    }
    //End Initialize 
  } 

  generateChart() {
      //debugger;
    //Chart Code Start    
    var ctrl = this;

    let labels = [];
    let expenditureSeries = [];
    let countSeries = [];

    this.data.map(item => {     
        labels.push(`${item.location}<br>${item.source}`);
        expenditureSeries.push(item.expenditure);
        countSeries.push(item.count);
    });

    const chartOptions = {
        chart: {
            type: 'column',
            height: '300'
        },
        title: {
            text: null
        },
        xAxis: {
            categories: labels,
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
                text: null
            }
        },
        credits: {
            enabled: false
        },        
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [
            {
                name: 'Spend (€)',
                data: expenditureSeries
            }, 
            {
                name: 'Count',
                data: countSeries
            }
        ]
    };

    return Highcharts.chart(this.chartContainerId, chartOptions);
    
    //Chart Code End
  }

  getGuid() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export default EnquiriesExpenditureController;



// WEBPACK FOOTER //
// ./client/app/components/leadMonitor/enquiriesExpenditure/enquiriesExpenditure.controller.js